import React from 'react';

function OperationMarkComponent() {
    return <div>OperationMarkComponent</div>;
}

export default OperationMarkComponent;
